import { createSlice } from "@reduxjs/toolkit";
import { submitRating, getUserRatings } from "./ratingService";

// Initial state
const initialState = {
  ratings: [],
  loading: false,
  error: null,
};

// Rating slice
const ratingSlice = createSlice({
  name: "rating",
  initialState,
  reducers: {
    clearRatingErrors: (state) => {
      state.error = null;
    },
    clearRatingData: (state) => {
      state.ratings = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Submit Rating
    builder
      .addCase(submitRating.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitRating.fulfilled, (state, action) => {
        state.loading = false;
        // Assuming the API returns the newly created rating
        if (action.payload.data) {
          state.ratings = [action.payload.data, ...state.ratings];
        }
      })
      .addCase(submitRating.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get User Ratings
      .addCase(getUserRatings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserRatings.fulfilled, (state, action) => {
        state.loading = false;
        state.ratings = action.payload.data;
      })
      .addCase(getUserRatings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearRatingErrors, clearRatingData } = ratingSlice.actions;
export default ratingSlice.reducer;
